<template>
    <div class="basic_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{data.title}}</div>
        </div>
        <div class="wrap">
            <div class="article-title">{{ data.title }}</div>

            <div class="article-cover">
                <img :src="data.img" alt="">
            </div>

            <div class="article-content" v-html="data.content"></div>
        </div>

    </div>
</template>

<script>
    import Fetch from "../../utils/fetch";

    export default {
        name: "detail",
        data() {
            return {
                data: {},
            }
        },
        created() {
            this.$parent.footer('index', false);
        },
        mounted() {
            this.start();
        },
        methods: {
            start() {
                Fetch('/index/getdoc', {
                    id: this.$router.history.current.params.id
                }).then(res => {
                    this.data = res.data;
                })
            },
        },
    }
</script>

<style lang="less" scoped>
    .back_left {
        background: url(../../views/images/item/back_b.png) no-repeat center center;
    }
    .big_tit{
        color: #000000;
        max-width: 75%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .wrap {
        padding: 16px;
        background: #f7f8fa;
    }

    /* 标题 */
    .article-title {
        font-size: 20px;
        font-weight: 600;
        color: #1a1a1a;
        line-height: 1.4;
        margin-bottom: 12px;
    }

    /* 封面图 */
    .article-cover {
        margin-bottom: 16px;
    }

    .article-cover img {
        width: 100%;
        display: block;
        border-radius: 6px;
    }

    /* 正文内容 */
    .article-content {
        font-size: 15px;
        color: #333;
        line-height: 1.8;
        word-break: break-word;
    }

    /* v-html 内部标签统一样式 */
    .article-content p {
        margin: 0 0 12px;
    }

    .article-content img {
        max-width: 100%;
        height: auto;
        display: block;
        margin: 12px auto;
    }

    .article-content h1,
    .article-content h2,
    .article-content h3 {
        margin: 16px 0 8px;
        font-weight: 600;
    }

    .article-content ul,
    .article-content ol {
        padding-left: 20px;
        margin-bottom: 12px;
    }

    .article-content li {
        margin-bottom: 6px;
    }

    .article-content a {
        color: #1989fa;
        word-break: break-all;
    }

    /* 代码块（如果有） */
    .article-content pre {
        background: #f5f5f5;
        padding: 12px;
        overflow-x: auto;
        border-radius: 4px;
        font-size: 13px;
    }

</style>